export default __webpack_public_path__ + "static/media/pros-cons-sourcing-from-online-wholesale-marketplaces.88390a60.svg";